import { MapUtils } from '../../utility/map-utils.js';
import {
  DataModel,
  DataModelBuilder,
  SerializationContext,
  SerializedData,
  cloneMap,
  isSameData,
  isSameMap,
  mapToData,
} from '../dto/dto.js';
import { Price } from './price.js';

export class PromoterEventStats extends DataModel {
  static readonly TYPE_ID: string = '637a0fbb7f3949c68f575a32706edfed';

  // Promoter statistics per ticket template.
  constructor(
        public readonly soldTickets: Map<string, number>,
        public readonly incomePerTicket: Map<string, Price>,
  ) {
    super();
  }

  get $typeId(): string {
    return PromoterEventStats.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): PromoterEventStats {
    return new PromoterEventStats(
        MapUtils.getMap(map, 'soldTickets', (k, v) => ({
          key: k,
          value: Number(v),
        })),
        MapUtils.getMap(map, 'incomePerTicket', (k, v) => ({
          key: k,
          value: Price.decode(String(v)),
        })),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'soldTickets': mapToData(this.soldTickets, (k, v) => ({
        key: k,
        value: v,
      })),
      'incomePerTicket': mapToData(this.incomePerTicket, (k, v) => ({
        key: k,
        value: v.encode(),
      })),
    };
  }

  clone(): this {
    return new PromoterEventStats(
        cloneMap(this.soldTickets, (v) => v),
        cloneMap(this.incomePerTicket, (v) => v.clone()),
    ) as this;
  }

  isSame(other: PromoterEventStats): boolean {
    if(this === other) {
      return true;
    }

    return isSameMap(other.soldTickets, this.soldTickets, (lh, rh) => lh === rh) &&
      isSameMap(other.incomePerTicket, this.incomePerTicket, (lh, rh) => isSameData(lh, rh));
  }
}

export class PromoterEventStatsBuilder extends DataModelBuilder<PromoterEventStats> {
  build(context: SerializationContext, map: SerializedData): PromoterEventStats {
    return PromoterEventStats.fromMap(context, map);
  }
}
